module.exports = __webpack_public_path__ + "static/media/boat-img-35.7a972dfe.jpg";